import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const UserNavbar = ({children}) => {
    const { user, logout } = useContext(AuthContext);

    return (
        <header className="bg-white shadow-sm sticky top-0 z-[100]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center py-4">
                    <div className="flex items-center gap-4">
                        <Link to="/" className="flex items-center gap-2">
                            <div className="w-10 h-10 rounded-full bg-orange-400 flex items-center justify-center text-white font-bold text-lg">
                                S
                            </div>
                            {children}
                            <span className="font-semibold text-lg">THTMG</span>
                        </Link>
                    </div>

                    <div className="flex items-center gap-4">
                        <span className="text-sm text-gray-600">
                            Welcome, <span className="font-medium">{user?.name}</span>
                        </span>
                        <button
                            onClick={logout}
                            className="bg-orange-500 text-white px-4 py-2 rounded text-sm font-semibold shadow-sm hover:bg-orange-600"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default UserNavbar;